function repositionContact() {
  if ($(".contact-image-block").length) {
    $(".contact-image-block").insertBefore(".content-wrapper-in");
    $(".form-panel > p:first-child").text("írj nekünk");
  }
}
